import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoginPageDomService {
    dynamicEl: HTMLElement;

    setDynamicContentElement(element: HTMLElement): void {
        this.dynamicEl = element;
    }

    getLoginForm(): HTMLElement {
        const loginForm = this.dynamicEl.querySelector('[aza-login-form]') as HTMLElement;
        return loginForm;
    }

    getSubmitButton(): HTMLElement {
        const loginFormEl = this.getLoginForm();
        const submitBtn = loginFormEl.querySelector('button[type="submit"]') as HTMLElement;
        return submitBtn;
    }

    getEmailFieldContainer(): HTMLElement {
        const emailContainerEl = this.dynamicEl.querySelector('[aza-login-email-section]') as HTMLElement;
        return emailContainerEl;
    }

    getEmailField(): HTMLInputElement {
        const emailFieldContainerEl = this.getEmailFieldContainer();
        const emailInputEl = emailFieldContainerEl.querySelector('[aza-login-email-field]') as HTMLInputElement;
        return emailInputEl;
    }

    getRegistrationCodeFieldContainer(): HTMLElement {
        const registrationCodeEl = this.dynamicEl.querySelector('[aza-login-registration-code-section]') as HTMLElement;
        return registrationCodeEl;
    }

    getRegistrationCodeField(): HTMLInputElement {
        const regCodeFieldContainer = this.getRegistrationCodeFieldContainer();
        const registrationCodeInputEl = regCodeFieldContainer.querySelector('[aza-login-registration-code-field]') as HTMLInputElement;
        return registrationCodeInputEl;
    }
}
